var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-109 -2896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5398",
    "data-name": "Rectangle 5398",
    transform: "translate(109 2896)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-delete-trash",
    d: "M14.357,4a2.8,2.8,0,0,0-2.786,2.786H6.7a.7.7,0,1,0,0,1.393H7.857V20.018a2.556,2.556,0,0,0,2.554,2.554h4.7a6.045,6.045,0,0,1-1-1.393h-3.7A1.162,1.162,0,0,1,9.25,20.018V8.179H19.464v4.179a6.043,6.043,0,0,1,1.393.168V8.179h1.161a.7.7,0,1,0,0-1.393H17.143A2.8,2.8,0,0,0,14.357,4Zm0,1.393A1.383,1.383,0,0,1,15.75,6.786H12.964A1.383,1.383,0,0,1,14.357,5.393Zm-1.636,5.1a.7.7,0,0,0-.686.706v6.964a.7.7,0,1,0,1.393,0V11.2a.7.7,0,0,0-.707-.706Zm3.261.01a.7.7,0,0,0-.7.7v2.847a6.045,6.045,0,0,1,1.393-1V11.2A.7.7,0,0,0,15.982,10.5Zm3.482,2.786a5.107,5.107,0,1,0,5.107,5.107A5.107,5.107,0,0,0,19.464,13.286Zm-2.321,2.321a.463.463,0,0,1,.328.136l1.993,1.993,1.993-1.993a.464.464,0,0,1,.657.657l-1.993,1.993,1.993,1.993a.464.464,0,1,1-.657.657l-1.993-1.993-1.993,1.993a.464.464,0,0,1-.657-.657l1.993-1.993L16.815,16.4a.464.464,0,0,1,.328-.793Z",
    transform: "translate(106 2894.25)",
    fill: "#314469"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete24);
export default __webpack_public_path__ + "static/media/delete_24.0323175f85744746b1b776d66bdb125e.svg";
export { ForwardRef as ReactComponent };